import React from "react";
import { useSelector } from "react-redux";
import {
	Box,
	FormLabel,
	IconButton,
	styled,
	Tooltip,
	tooltipClasses,
	TooltipProps,
	Typography,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { ESRQuestionConfig, ESRState } from "../types/data";

export const CustomTooltip = styled(
	({ className, children, ...props }: TooltipProps) => (
		<Tooltip {...props} classes={{ popper: className }}>
			{children}
		</Tooltip>
	),
)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		fontSize: 14,
	},
}));

export const ESRQuestionLabel = (props: ESRQuestionConfig) => {
	const {
		question_id,
		question_text,
		question_help,
		field_type,
		required,
		autofill,
		inline
	} = props;

	const esr_sponsor_type = useSelector(
		(state: ESRState) => state.esr_sponsor_type,
	);
	const isVAL = question_id?.endsWith("_VAL");
	return (
		<Box id={question_id} style={{ height: "100%" }}>
			{field_type != "label" ? (
				<FormLabel sx={{ color: "black" }} htmlFor={question_id}>
					<Box
						sx={{
							height: "100%",
							display: "flex",
							alignItems: "center",
							"&:hover .toggle-button": {
								opacity: 1,
							},
						}}
					>
						<Typography
							sx={{
								mx: "4px",
								fontFamily: "Roboto",
								fontSize: "14px",
								fontWeight: 500,
							}}
						>
							{field_type == "header" ? (
								<>
									<span style={{ fontSize: "18px" }} title={question_text}>
										{question_text}
									</span>
								</>
							) : (
								<>
									<span title={question_text} style={{ whiteSpace: "pre-wrap" }}>
										<span 
											style={{ 
												color: "#cc0000", 
												fontSize: "10px" 
											}}
										>
											{required ? "* " : ""}
											{inline ? null : question_id.split(".").slice(-1)}
										</span>{" "}
										<span
														style={{
															backgroundColor: isVAL ? "#d4f5dd" : "transparent",
															color: isVAL ? "#1b7f3a" : "inherit",
															padding: isVAL ? "2px 4px" : "0",
															borderRadius: isVAL ? "4px" : "0",
														}}
													>
														{question_text}
													</span>

									</span>
								</>
							)}
						</Typography>
						{question_help ? (
							<CustomTooltip
								arrow
								placement="top"
								title={
									<>
										{question_help}
										<span style={{ color: "red" }}>
											{autofill.includes("TREC")
												? " (automatically filled)"
												: autofill.includes("PPS") &&
														esr_sponsor_type == "State"
													? " (from PPS)"
													: autofill.includes("WMFT") &&
															esr_sponsor_type == "Local"
														? " (from WMFT)"
														: ""}
										</span>
									</>
								}
							>
								<IconButton aria-label={question_help}>
									<InfoOutlined fontSize="medium" sx={{ color: "#003E62" }} />
								</IconButton>
							</CustomTooltip>
						) : null}
					</Box>
				</FormLabel>
			) : null}
		</Box>
	);
};
